import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from '../../../../shared/modal/FormModal';
import TextArea from '../../../../shared/input/TextArea';
import Dropdown from '../../../../shared/dropdown/Dropdown';
import { getCurrentWorkOrder } from '../../../../../selectors/admin/work-orders/work-orders';
import {
  setShowAddOpenItemModal,
  submitFormRequest,
  updateFormValue,
} from '../../../../../actions/admin/work-orders/details/open-items';
import {
  getForm,
  getInvalidFields,
  getMembers,
  getShowAddOpenItemModal,
  getValidationMessage,
} from '../../../../../selectors/admin/work-orders/details/open-items';
import RouteTitle from '../../../../shared/route-title/RouteTitle';
import numeral from 'numeral';
import {
  getCurrentTask,
  getOpenItemsByTaskId,
} from '../../../../../selectors/admin/work-orders/details/details';
import './AddOpenItemModal.css';
import CheckBox from '../../../../shared/checkbox/CheckBox';
import DatetimePicker from '../../../../shared/datetime-picker/DatetimePicker';
import { todayValidation } from '../../../../../services/utils/date-util';

class AddOpenItemModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowAddOpenItemModal(false));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.dispatch(
      submitFormRequest(this.props.currentTask.id, this.props.form)
    );
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  render() {
    return (
      <FormModal
        className="add-open-item-modal"
        show={this.props.showAddOpenItemModal}
        subTitle={
          <RouteTitle
            titles={[
              this.props.currentWorkOrder.client.company_name.toUpperCase(),
              `TASK #${this.props.currentWorkOrder.number}-${numeral(
                this.props.currentTask.number
              ).format('00')}-${this.getNextLetter()}`,
            ]}
          />
        }
        title="New Open Item"
        onClose={this.handleClose}
      >
        <div>
          <Dropdown
            className="assigned-member-dropdown"
            disabled={this.props.members.length === 0}
            options={this.props.members
              // Show only active users who has not the role OWNER
              .filter((member) => member.user.status === 'active')
              .map((member) => {
                return {
                  value: member.user.id,
                  label: `${member.user.first_name} ${member.user.last_name}`,
                };
              })}
            placeholder="Assigned To"
            valid={
              this.props.invalidFields.find(
                (element) => element === 'memberId'
              ) === undefined
            }
            value={this.props.form.memberId}
            onChange={(newOption) =>
              this.handleAttributeChange('memberId', newOption.value)
            }
          />
        </div>

        <div>
          <DatetimePicker
            isValidDate={todayValidation}
            placeholder="Due Date"
            valid={
              this.props.invalidFields.find(
                (element) => element === 'dueDate'
              ) === undefined
            }
            value={this.props.form.dueDate}
            onChange={this.handleAttributeChange.bind(this, 'dueDate')}
          />
        </div>

        <div>
          <TextArea
            placeholder="Open Item Description..."
            valid={
              this.props.invalidFields.find(
                (element) => element === 'description'
              ) === undefined
            }
            value={this.props.form.description}
            onChange={this.handleAttributeChange.bind(this, 'description')}
          />
        </div>

        <div>
          <CheckBox
            checked={this.props.form.critical}
            shape="round"
            size="medium"
            onChange={this.handleAttributeChange.bind(
              this,
              'critical',
              !this.props.form.critical
            )}
          />
          <span>Mark as Critical</span>
        </div>

        {this.props.validationMessage !== '' && (
          <div className="invalid-message">{this.props.validationMessage}</div>
        )}

        <div className="button-container">
          <input
            type="button"
            className="btn button button-orange"
            value="Create Open Item"
            onClick={this.handleSubmit}
          />
        </div>
      </FormModal>
    );
  }

  getNextLetter() {
    const openItems =
      this.props.openItemsByTaskId !== null
        ? this.props.openItemsByTaskId[this.props.currentTask.id]
        : undefined;
    if (openItems === undefined) {
      return 'A';
    } else {
      return String.fromCharCode(65 + openItems.length); // 65 unicode for 'A' (upper case)
    }
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    members: getMembers(state),
    openItemsByTaskId: getOpenItemsByTaskId(state),
    showAddOpenItemModal: getShowAddOpenItemModal(state),
    validationMessage: getValidationMessage(state),
  };
})(AddOpenItemModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/open-items/AddOpenItemModal.js